import Vue from 'vue'
const engine = require('store/src/store-engine')
const isDevelopment = process.env.NODE_ENV === 'development'
const storages = isDevelopment ? [
  // require('store/storages/localStorage'),
  require('store/storages/cookieStorage')
] : [
  require('store/storages/localStorage'),
  require('store/storages/cookieStorage')
]
var plugins = [
  require('store/plugins/defaults')
]

export const storage = engine.createStore(storages, plugins)

export const setAuth = (auth) => {
  storage.set('auth', auth)
}

export const getAuth = () => {
  return storage.get('auth')
}
export const clearAuth = () => {
  storage.remove('auth')
}

export const setMixAuth = (auth) => {
  storage.set('mixAuth', auth)
}
export const getMixAuth = () => {
  return storage.get('mixAuth')
}
export const clearMixAuth = () => {
  storage.remove('mixAuth')
}

export const setStorage = (name, val) => {
  storage.set(name, val)
}
export const getStorage = (name) => {
  return storage.get(name)
}
export const clearStorage = (name) => {
  storage.remove(name)
}
//  语言
export const setLang = (lang) => {
  storage.set('lang', lang)
}
export const getLang = () => {
  return storage.get('lang')
}
export const clearLang = () => {
  storage.remove('lang')
}
// pid
export const setPid = (pid) => {
  storage.set('pid', pid)
}
export const getPid = () => {
  return storage.get('pid')
}
export const clearPid = () => {
  storage.remove('pid')
}

// newAuth
export const setNewAuth = (auth) => {
  storage.set('newAuth', auth)
}
Vue.prototype.$isEnglish = getLang() === 'en'
